<template>
  <div class="producer-audit">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">IP名称</span>
        <el-input class="w200" maxlength="20" v-model="ipName" placeholder="请输入IP名称"></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">状态</span>
        <el-select v-model="checkStatus" placeholder="请选择状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核失败" value="2"></el-option>
        </el-select>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="getList">筛选</el-button>
      </div>
    </div>
    <el-table :data="tableData" row-key="designId" style="width: 100%" size="middle" border stripe>
      <!-- <el-table-column prop="id" label="ID" align="center"></el-table-column> -->
      <el-table-column label="IP图案" align="center">
        <template slot-scope="scope">
          <img @click="searchBig(scope.row.designUrl)" :src="scope.row.designUrl + '?x-oss-process=image/resize,w_200'" width="100" style="cursor: pointer" />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="IP名称" align="center"></el-table-column>
      <el-table-column prop="authorName" label="作者" align="center"></el-table-column>
      <el-table-column prop="publishTime" label="发布时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.publishTime || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <el-link v-if="scope.row.checkStatus == 2" @click="searchFailReason(scope.row.checkReason)" type="primary">{{ checkStatusObj[scope.row.checkStatus] }}</el-link>
          <span v-else>{{ checkStatusObj[scope.row.checkStatus] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="showAuditModal(scope.row.designId)">审核</el-button>
          <el-button size="small" type="primary" @click="searchDetail(scope.row.designId)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination background :page-count="totalPage" :current-page="pageNum" @current-change="getList" layout="prev, pager, next, jumper"></el-pagination>
    </div>
    <el-dialog @close="diaglogClose" :close-on-click-modal="false" title="IP详情" :visible.sync="showAddPop" width="500px">
      <el-form v-if="showAddPop" :model="addForm" size="small" label-width="100px">
        <el-form-item label="IP名称">
          <el-input v-model="addForm.name" readonly maxlength="30" placeholder="请输入IP名称"></el-input>
        </el-form-item>
        <el-form-item label="生产者">
          <el-input v-model="addForm.authorName" readonly maxlength="30" placeholder="请输入IP名称"></el-input>
        </el-form-item>
        <el-form-item label="国家">
          <el-select disabled v-model="addForm.countryType">
            <div v-for="item in countryList" :key="item.value">
              <el-option :label="item.name" :value="item.value"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-select disabled :loading="addForm.categoryLoading" v-model="addForm.categoryId">
            <div v-for="item in this.categoryList" :key="item.categoryId">
              <el-option :label="item.categoryName" :value="item.categoryId"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="版权方">
          <template>
            <el-radio disabled v-model="addForm.authorType" label="1">自有版权</el-radio>
            <el-radio disabled v-model="addForm.authorType" label="2">所属公司</el-radio>
            <el-input v-model="addForm.authorInfo" disabled placeholder="请输入所属公司"></el-input>
          </template>
        </el-form-item>
        <el-form-item label="状态">
          <el-select disabled v-model="addForm.status" placeholder="请选择">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-select disabled v-model="addForm.baseColor" placeholder="请选择">
            <el-option label="白" value="W"></el-option>
            <el-option label="黑" value="B"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="IP图案">
          <el-upload :on-preview="onPreview" class="upload-demo" disabled action="" :data="addForm.ossDataImg" :limit="1" list-type="picture" :file-list="addForm.designKeyList" accept="image/png">
            <el-button disabled size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持png, 小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="矢量文件">
          <el-upload :on-preview="() => download(addForm.designPdf, addForm.designId)" class="upload-demo" disabled action="" :data="addForm.ossDataPdf" :limit="1" accept="application/pdf" :file-list="addForm.designPdfList">
            <el-button disabled size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持pdf, 小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="介绍文件">
          <el-upload :on-preview="() => download(addForm.introduceFile)" class="upload-demo" disabled action="" :data="addForm.ossDataFile" :limit="1" :file-list="addForm.introduceFileList" accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
            <el-button disabled size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持word, 小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="标签">
          <div class="tagList">
            <el-tag v-for="(tag, index) in addForm.tagList" style="margin-bottom:5px;" :key="tag.tagId">
              {{ tag.tagName }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="作品简介">
          <el-input readonly type="textarea" :rows="3" maxlength="300" placeholder="请输入内容" show-word-limit v-model="addForm.remark"> </el-input>
        </el-form-item>
        <el-form-item label="授权品类">
          <el-checkbox-group disabled v-model="addForm.extAuthTypeIds">
            <el-checkbox
              v-for="item in authCategoryList"
              :key="item.id"
              :label="item.id"
              name="type"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="设计要求">
          <el-radio-group disabled v-model="addForm.designRequirementId">
             <el-radio v-for="item in designRequirementList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
          </el-radio-group>
          <el-input disabled placeholder="请输入设计要求" v-model="addForm.designRequirement"></el-input>
        </el-form-item>
        <el-form-item label="推广应用">
          <el-checkbox-group disabled v-model="addForm.extensionAppIds">
            <el-checkbox v-for="item in appList" :key="item.id" :label="item.id" name="type">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button type="primary" @click="showAddPop = false">确 定</el-button>
      </div>
    </el-dialog>
    <AuditDialog ref="auditDialog" @fail="fail" @success="success" />
    <el-dialog :close-on-click-modal="false" title="设计图" :visible.sync="designImgVisible" width="500px">
      <div v-if="designImgVisible">
        <img :src="currentDesignImgUrl" style="width: 100%;" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API, {baseUrl} from '../lib/API'
import AuditDialog from '../components/common/AuditDialog.vue'
import { dataTypeList, countryList } from '../lib/constObj.js'
export default {
  name: 'ProducerAudit',
  components: {
    AuditDialog
  },
  data() {
    return {
      designImgVisible: false,
      tableData: [],
      pageNum: 1,
      totalPage: 0,
      ipName: '',
      checkStatus: '',
      currentDesignId: '',
      checkStatusObj: {
        0: '待审核',
        1: '审核通过',
        2: '审核失败'
      },
      addForm: {
        countryType: '2',
        designId: '',
        baseColor: '',
        categoryId: '',
        designKey: '',
        designPdf: '',
        introduceFile: '',
        ossDataImg: {},
        ossDataPdf: {},
        ossDataFile: {},
        designKeyList: [],
        designPdfList: [],
        introduceFileList: [],
        designRequirementId: "",
        designRequirement: "",
        extAuthTypeIds: [],
        extensionAppIds: [],
        status: 1,
        name: '',
        authorName: '',
        authorType: '1',
        price: 1,
        level: 1,
        tagName: '',
        tagIds: [],
        tagList: [],
        remark: '',
        authorInfo: '',
        // shopId: '',
        dataType: '1',
      },
      categoryList: [],
      countryList: countryList,
      dataTypeList: dataTypeList,
      countryObj: {},
      dataTypeObj: {},
      showAddPop: false,
      dataType: '1',
      designRequirementList: [],
      authCategoryList: [],
      appList: []
    }
  },
  created () {
    this.dealObj();
    this.getCategoryList()
    this.getList();
    this.getAuthCategoryList()
    this.getAppList()
    this.getDesignList();
  },
  methods: {
    searchFailReason(reason) {
      this.$alert(reason, '失败原因')
    },
    download(designPdf, designId) {
      let a = document.createElement('a')
      a.href = `${baseUrl}/download/image?key=${designPdf}&designId=${designId || 
      ''}&accesstoken=${localStorage.getItem('token')}`
      a.click()
    },
    searchBig (url) {
      this.designImgVisible = true
      this.currentDesignImgUrl = url
    },
    onPreview (file) {
      this.searchBig(file.url)
    },
    diaglogClose() {
      this.addForm = {
        countryType: '2',
        baseColor: '',
        categoryId: '',
        designKey: '',
        designPdf: '',
        introduceFile: '',
        ossDataImg: {},
        ossDataPdf: {},
        ossDataFile: {},
        designKeyList: [],
        designPdfList: [],
        introduceFileList: [],
        designRequirementId: "",
        designRequirement: "",
        extAuthTypeIds: [],
        extensionAppIds: [],
        status: 1,
        name: '',
        authorName: '',
        authorType: '1',
        price: 1,
        level: 1,
        tagName: '',
        tagIds: [],
        tagList: [],
        remark: '',
        authorInfo: '',
        shopId: '',
        dataType: '1',
      }
    },
    searchDetail(id) {
      this.showAddPop = true
      this.getIpDetail(id)
    },
    dealObj() {
      this.dataTypeList.forEach(item => {
        this.dataTypeObj[item.value] = item.name
      })
      this.countryList.forEach(item => {
        this.countryObj[item.value] = item.name
      })
    },
    showAuditModal(designId) {
      this.currentDesignId = designId
      this.$refs.auditDialog.showModal()
    },
    getIpDetail (id) {
      new API(this).POST({
        url: '/design/getDesignDetail?designId=' + id,
        cb: res => {
          Object.assign(this.addForm, res)
          res.author = res.author || {}
          this.addForm.tagList = res.tags
          this.addForm.tagIds = res.tags.map(item => item.tagId)
          this.addForm.authorName = res.author.authorName
          this.addForm.authorId = res.author.authorId
          this.addForm.dataType = String(res.category.dataType)
          this.addForm.shopId = res.category.shopId
          this.addForm.authorId = res.author.authorId
          this.addForm.price = res.price || 1
          this.addForm.categoryId = res.category.categoryId
          this.addForm.designKeyList = [{ name: this.getFileName(res.designKey), url: res.designUrl }]
          if (res.designPdf) {
            this.addForm.designPdfList = [{ name: this.getFileName(res.designPdf), url: res.designPdfUrl }]
          } else {
            this.addForm.designPdfList = []
          }
          if (res.introduceFile) {
            this.addForm.introduceFileList = [{ name: this.getFileName(res.introduceFile), url: res.introduceFileUrl }]
          } else {
            this.addForm.introduceFileList = []
          }
        }
      })
    },
    getFileName(str) {
      return str.split('/').pop()
    },
    getCategoryList() {
      // 图案分类
      new API(this).POST({
        url: '/designCategory/findAllEndableDesignCategoryList',
        params: {
          dataType: this.dataType,
          shopId: this.shopId
        },
        cb: res => {
          this.categoryList = res
        }
      })
    },
    hideAuditModal() {
      this.$refs.auditDialog.hideModal()
    },
    fail(reason) {
      this.auditMethod(2, reason)
    },
    success() {
      this.auditMethod(1, '')
    },
    auditMethod(checkStatus, checkReason) {
      new API(this).POST({
        url: '/design/checkDesignInfo',
        params: {
          designId: this.currentDesignId,
          checkStatus,
          checkReason
        },
        cb: res => {
          this.getList()
        }
      })
    },
    getList(val) {
      if (!isNaN(val)) {
        this.pageNum = val
      } else {
        this.pageNum = 1
      }
      new API(this).POST({
        url: '/design/checkWithPage',
        params: {
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          name: this.ipName,
          checkStatus: this.checkStatus
        },
        cb: res => {
          let { pages, result } = res

          this.totalPage = pages
          this.tableData = result
        }
      })
    },
    withdraw() {
      console.log('确认提现')
    },
    showWithdraw() {
      this.withdrawVisiable = true
    },
    showWithDraied() {
      this.withdraiedVisiable = true
    },
    getAuthCategoryList() {
      new API(this).POST({
        url: "/designExtType/findAuthType",
        cb: res => {
          this.authCategoryList = res;
        }
      });
    },
    getAppList() {
      new API(this).POST({
        url: "/designExtType/findExtensionApp",
        cb: res => {
          this.appList = res;
        }
      });
    },
    getDesignList() {
      new API(this).POST({
        url: "/designExtType/findDesignRequirement",
        cb: res => {
          this.designRequirementList = res;
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
producer-audit {
  
}
</style>



// WEBPACK FOOTER //
// src/components/IpAudit.vue